import React from 'react'
import Box from '@mui/material/Box'
import { Container, Typography, Grid } from '@mui/material'
import { work_Data } from '../../Data/work_Data'
import './Work.css'

const work = () => {
  return (
    <div className="workmain" id="work">
      <Container className="work" sx={{ textAlign: 'center' }}>
        <Typography variant="h4" color="initial" fontWeight={600} >How It Works</Typography>
        <Typography variant="h6" color='secondary' sx={{ marginTop: '17px' }}>Streamline your insurance proposal process with Certiform.</Typography>
        <Grid container spacing={2} sx={{ paddingTop: '50px', textAlign: 'center' }}>
          { 
            work_Data.map((data) => {
              return (
                <Grid item xs={12} sm={4} md={{ marginTop: `${data.marginTop}` }} sx={{marginTop:'20px'}}>
                  <Box style={{ textAlign: 'center' }}>
                    <img src={data.image} alt="" width={80} />
                    <Typography variant="h6" color="initial" fontWeight={600}>{data.title}</Typography>
                    <Box style={{ width: '100%', textAlign: 'center', padding: "0 50px" }}>
                      <Typography variant="body1" color='secondary' sx={{ marginTop: '17px' }}>{data.description}</Typography>
                    </Box>
                  </Box>
                </Grid>
              )
            })
          }
        </Grid>
      </Container>
    </div>
  )
}

export default work